import React from "react";
import CategoryHead from "../../../../components/categoryhead";
import styled, { withTheme } from "styled-components";
import { EDGE_SPACING } from "../consts";
import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import { cloud, ninja } from "@vitalsource/vstui/colors";

// changed to 18px, to accomodate vstui button padding alignment.
// Redesigned categoryhead.js for vpat reasons.
const HeadContainer = styled.div`
  padding: 0 ${EDGE_SPACING}px 0 18px;
  display: flex;
  margin-top: 43px;
  margin-bottom: 20px;
`;

const LeftSideButtonContainer = styled.div`
  text-align: left;
`;

const RightSideButtonContainer = styled.div`
  flex: 1 0 0;
  text-align: right;
`;

const CategoryButtons = createThemedComponent(Button, props => ({
  Button_borderColor_white_hover: props.theme.color.primary.getShade(8),
  Button_borderColor_white_focus: props.theme.color.primary.getShade(8),
  Button_backgroundColor_themePrimary_hover: props.theme.color.primary.getShade(
    1
  ),
  Button_backgroundColor_white: props.theme.color.primary.getShade(1),
  Button_backgroundColor_white_focus: props.theme.color.primary.getShade(1),
  Button_color_white: cloud.getShade(10),
  Button_color_white_hover: cloud.getShade(10),
  Button_color_white_focus: cloud.getShade(10),
  Button_backgroundColor_white_hover: props.theme.color.primary.getShade(1),
  Button_borderRadius: "54px"
}));

export const CategoryButton = styled(CategoryButtons)`
  margin-left: 15px;
  box-shadow: 0px 0px 0px 1px ${cloud.getShade(5)} inset;
  background: ${props => props.theme.color.primary.getShade(1)};
  button[aria-selected="true"],
  &[aria-selected="true"] {
    background: ${props => props.theme.color.primary.getShade(3)};
  }
`;

class GridFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCheckboxChange = e => {
    const key = e.currentTarget.value;
    this.setState(prevState => ({
      [key]: !prevState[key]
    }));
  };

  render() {
    const {
      onHeaderClick,
      headerLabel,
      filterButtons,
      theme,
      lastLabel,
      filtersOn
    } = this.props;
    return (
      <HeadContainer>
        <LeftSideButtonContainer>
          <CategoryHead
            onClick={onHeaderClick}
            label={headerLabel}
            caretLeft={!!onHeaderClick}
            lastLabel={lastLabel}
          />
        </LeftSideButtonContainer>
        <RightSideButtonContainer data-testid="GridFilter__RightSideButtonContainer">
          {filtersOn &&
            filterButtons.map(button => (
              <CategoryButton
                key={`button-${button.buttonID}`}
                color="white"
                colorBehindButton={theme.color.primary.getShade(1)}
                onClick={button.buttonClick}
                aria-pressed={button.selected}
                size="small"
              >
                {button.buttonText}
              </CategoryButton>
            ))}
        </RightSideButtonContainer>
      </HeadContainer>
    );
  }
}

export default withTheme(GridFilter);
